export function inputRepair(input) {
  let newArray = [];
  let uniqueObject = {};

  for (let i in input) {
    let objTitle = input[i]['sealNo'];
    uniqueObject[objTitle] = input[i];
  }

  for (let i in uniqueObject) {
    newArray.push(uniqueObject[i]);
  }

  return (dispatch) => {
    dispatch({type: 'SET_INPUT_REPAIR', payload: newArray});
  };
}

export function resetInputRepair() {
  return (dispatch) => {
    dispatch({type: 'RESET_INPUT_REPAIR', payload: new Array(0)});
  };
}

export function dataNoSeal(data) {
  return (dispatch) => {
    dispatch({type: 'SET_DATA_SEAL_NO', payload: data});
  };
}

export function resetdataNoSeal() {
  return (dispatch) => {
    dispatch({type: 'RESET_DATA_SEAL_NO', payload: new Array(0)});
  };
}
